import bemify from 'bemify-js';

import { buildCommonComponent } from '@zapier/legacy-components';

import Badge from 'app/common/components/Badge';
import Button from 'app/common/components/Button';
import LinkPreserveParamsContainer from 'app/common/components/LinkPreserveParamsContainer';
import 'app/viewport/components/Header/HeaderBlock.scss';

const bem = bemify('header-block');

export const buildCommonHeaderComponent = buildCommonComponent(bem());

export const HeaderBlock = buildCommonHeaderComponent();
export const HeaderBlockContainer = buildCommonHeaderComponent('__container');
export const HeaderBlockInnerWrapper = buildCommonHeaderComponent('__wrapper');
export const HeaderBlockOverlay = buildCommonHeaderComponent('__overlay', 'a');
export const HeaderBlockMenuControls = buildCommonHeaderComponent('__controls');
export const HeaderBlockHeaderLinks = buildCommonHeaderComponent(
  '__links-container'
);

export const HeaderMenuButton = buildCommonHeaderComponent(
  '__menu-button',
  Button
);

export const HeaderSignUpCta = buildCommonHeaderComponent(
  '__sign-up-cta',
  LinkPreserveParamsContainer
);

export const HeaderBadge = buildCommonHeaderComponent(
  '__developer-badge',
  Badge
);

export default HeaderBlock;
